'use strict';

function functionMatcher(fn) {
  return function(el, i, arr) {
    // Return true up front if match by reference
    return el === fn || fn.call(arr, el, i, arr);
  };
}

module.exports = functionMatcher;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/functionMatcher.js
// module id = 719
// module chunks = 0